export { default } from './TaskParamsBlock';



// WEBPACK FOOTER //
// ./src/components/Tasks/_common/TaskParamsBlock/index.js